export const MAX_UPLOAD_COUNT = 25;
export const MAX_UPLOAD_SIZE = 20000000;

export const MAX_UPLOAD_SIZE_DISPLAY = `${MAX_UPLOAD_SIZE / 1000000} MB`;

export const ATTACHMENT_UPLOAD_GUIDELINES = `You can select up to ${MAX_UPLOAD_COUNT} image, video, Word, Excel, text, HTML, \
        or non-password protected PDF files. All files must total less than ${MAX_UPLOAD_SIZE_DISPLAY}.`;

export const FILE_TYPES = {
  IMAGE: 'image', // use with .includes since an image can be image/jpg, image/png, etc.
  VIDEO: 'video', // use with .includes since a video can be .mp4, .mov, etc.
};

export const ATTACHMENT_STATUS = {
  IMPERSONATION_DETECTED: 'impersonation-detected',
  STATUS_COMPLETE: 'complete',
};
